import {
  GraphQLPaginationType,
  PaginationDirection,
} from 'commonTypes'
import {
  JobCreatorOptions,
  JobRequestFilterInput,
  KafkaTopicState,
  SortEnumType,
} from 'graphql-api'
import {
  SelectorOptionType,
  TopicOptionType,
  DatabaseOptionType,
  StudyOptionType,
  filterOptionsType,
  StudyEnvironmentOptionType,
} from 'redux/jobRequests/state'

export const getSelectorJobRequestCategoryOptions = (jobCreatorOptions: JobCreatorOptions[]) => {
  const selectorOptionsArray = [] as SelectorOptionType[]
  jobCreatorOptions.filter(category => !category.hidden).map(option => (
    selectorOptionsArray.push({
      value: option.category,
      label: option.categoryName,
    })
  ))
  return selectorOptionsArray
}

export const getSelectorSettingsForCategory = (category, jobRequestOptions) => {

  return jobRequestOptions.find(o => o.category == category.value)
}

export const getSelectorDataLoadTopicOptions = (category) => {
  const selectorOptionsArray = [] as TopicOptionType[]
  if (category?.kafkaTopics) {
    category.kafkaTopics.map(option => (
      selectorOptionsArray.push({
        value: option,
        label: option.name,
      })
    ))
  }
  return selectorOptionsArray
}

export const getDataLoadSelectorSettingsForTopic = (topic, jobRequestOptions) => {
  return jobRequestOptions.find(o => o.kafkaTopic === topic.value)
}

export const getSelectorDatabaseOptions = (options: DatabaseOptionType[], showAllSelectors: boolean) => {
  let databaseOptions = options.map(option => ({
    value: option.databaseId,
    label: option.hostname,
    subLabel: option.databaseId,
  }))
  
  if (showAllSelectors) {
    databaseOptions = [
      {
        value: '',
        label: 'All',
        subLabel: 'All',
      },
      {
        value: '',
        label: 'Specify Urls',
        subLabel: 'Specify Urls',
      },
    ].concat(databaseOptions)
  }

  return databaseOptions
}

export const getSelectorStudyOptions = (options: StudyOptionType[]) =>
  options.map(option => ({
    value: option.studyName,
    label: option.studyName,
    subLabel: option.studyUuid,
  }))

export const getSelectorStudyEnvironmentOptions = (options: StudyEnvironmentOptionType[]) =>
  options.map(option => ({
    value: option.studyId,
    label: option.studyEnvironmentName,
    subLabel: option.studyEnvironmentUuid,
  }))

export const getSelectorDataVerificationHashObjectOptions = (options) =>
  options.map(option => ({
    value: option,
    label: option.replace(/_/g, ' '),
  }))

export const getSelectValue = (value: string, name: string) => value?.length
  ? ({value: value, label: name})
  : null

export const getStudyEnvironmentSelectValue = (value: number, name: string, uuid: string) => name?.length
  ? ({value: value, label: name, subLabel: uuid})
  : null

export const getSelectTopicValue= (value: KafkaTopicState|null, name: string) => value
  ? ({value: value, label: name})
  : null

export const getFilterOptions = (jobCreatorOptions: JobCreatorOptions[]) => {
  const filterOptions: filterOptionsType[] = []
  jobCreatorOptions.forEach(o => {
    if (!filterOptions.find(x => x.value == o.category)) {
      filterOptions.push({value: o.category, gql: o.category, label: o.category.split('_').join(' ')})
    }
  })
  return filterOptions.sort((a, b) => a.value.localeCompare(b.value))
}
export const createGqlPagination = ({pageSize, pageDirection, startCursor, endCursor}) => {

  const params = {first: null, after: null, last: null, before: null} as GraphQLPaginationType
  switch (pageDirection) {
  case PaginationDirection.NEXT:
    return {
      ...params,
      first: pageSize,
      after: endCursor,
    }
  case PaginationDirection.PREV:
    return {
      ...params,
      last: pageSize,
      before: startCursor,
    }
  case null:
    return {
      ...params,
      first: pageSize,
    }
  }
}

export const createGraphQLFilter = ({category}, jobRequestOptions) => {
  const filterOptions = getFilterOptions(jobRequestOptions)
  const graphQLFilterToApply = {
    category: category ? {
      eq: filterOptions.find(f => f.value === category)?.gql,
    } : {},

  }
  return graphQLFilterToApply as JobRequestFilterInput
}

export const createGqlSorting = ({id, desc}) => ({[id]: desc ? SortEnumType.Desc : SortEnumType.Asc})

export const getJobStatusRequestsParams = ({pageSize, startCursor, endCursor, sorting, pageDirection, category, jobRequestOptions}) => {
  return {
    gqlPagination: createGqlPagination({pageSize, pageDirection, startCursor, endCursor}) as GraphQLPaginationType,
    gqlSorting: createGqlSorting(sorting),
    gqlFilter: createGraphQLFilter({category}, jobRequestOptions),
  }
}
